export const callIncomingWithParametersConvertRedux = (
  integrationinname: string,
  request: any,
  parameters: any,
  headers: any,
  actionType: string,
  failureCallback: (err?: any) => void | null,
  thingId?: number,
) => {
  window.parent.primingcloudRedux.integration.callIncomingWithParametersConvert(
    integrationinname,
    thingId ? thingId : 0,
    request,
    parameters,
    headers,
    actionType,
    failureCallback,
  )
}

export const callIncomingConvertRedux = (
  integrationinname: string,
  request: any,
  actionType: string,
  failureCallback: (err?: any) => void | null,
  thingId?: number,
) => {
  window.parent.primingcloudRedux.integration.callIncomingConvert(
    integrationinname,
    thingId ? thingId : 0,
    request,
    actionType,
    failureCallback,
  )
}

export const callIncomingRedux = (
  integrationinname: string,
  request: any,
  actionType: string,
  thingId?: number,
) => {
  window.parent.primingcloudRedux.integration.callIncoming(
    integrationinname,
    thingId ? thingId : 0,
    request,
    actionType,
  )
}

export const callIncomingDataEntryRedux = (
  integrationinname: string,
  request: any,
  actionType: string,
  thingId?: number,
) => {

  window.parent.primingcloudRedux.integration.callIncomingDataEntry(
    integrationinname,
    thingId ? thingId : 0,
    request,
    actionType
  )
}

export const callIncomingWithParametersRedux = (
  integrationinname: string,
  request: any,
  parameters: any,
  headers: any,
  actionType: string,
  thingId?: number,
) => {
  window.parent.primingcloudRedux.integration.callIncomingWithParameters(
    integrationinname,
    thingId ? thingId : 0,
    request,
    parameters,
    headers,
    actionType
  );
}

export const callIncomingDataEntryWithParametersRedux = (
  integrationinname: string,
  request: any,
  parameters: any,
  headers: any,
  actionType: string,
  thingId?: number,

) => {

  window.parent.primingcloudRedux.integration.callIncomingDataEntryWithParameters(
    integrationinname,
    thingId ? thingId : 0,
    request,
    parameters,
    headers,
    actionType,
  )
}
